/**
 * Cerrar un desplegable con `Escape` o pulsando fuera · 13-10-2026
 *
 * Lo necesitan el «Más» de la barra, la campana, el menú de cuenta y la hoja de
 * secciones del móvil: un desplegable que se queda abierto tapando la pantalla es
 * peor que no tenerlo, y es el fallo típico de hacerlo sin librería.
 */
import { useEffect, type RefObject } from 'react';

export function useCerrarAlSalir(
  abierto: boolean,
  caja: RefObject<HTMLElement | null>,
  cerrar: () => void
): void {
  useEffect(() => {
    if (!abierto) return;
    const alPulsarTecla = (e: KeyboardEvent) => {
      if (e.key === 'Escape') cerrar();
    };
    const alClicarFuera = (e: MouseEvent) => {
      if (!caja.current?.contains(e.target as Node)) cerrar();
    };
    document.addEventListener('keydown', alPulsarTecla);
    document.addEventListener('mousedown', alClicarFuera);
    return () => {
      document.removeEventListener('keydown', alPulsarTecla);
      document.removeEventListener('mousedown', alClicarFuera);
    };
  }, [abierto, caja, cerrar]);
}
